import common from '../common';
import DrawingTextureHackFrame from './DrawingTextureHackFrame';

export default class DrawingTextureHack {
	static create(path, slot, center) {
		center = center || new PIXI.Point();
		path.remove();

		// calculate the path offset from the center - we need this later when replicating hacks
		const offset = new PIXI.Point(path.position.x - center.x, path.position.y - center.y);

		// we need to calculate the amount the current sprite is rotated because we could be drawing rotated sprite
		// this means our texture must be pre-rotated in the opposite direction
		const sprite = slot.currentSprite ? slot.currentSprite : slot.currentMesh ? slot.currentMesh : null;
		const rotation = sprite ? slot.bone.localToWorldRotation(sprite.rotation * PIXI.RAD_TO_DEG) * PIXI.DEG_TO_RAD : 0;

		// create the first frame
		const frames = [DrawingTextureHackFrame.create(path, center, -rotation, 0)];

		// create alternative frames
		const alternatives = 1;
		for (const pathChild of path.children) {
			if (pathChild.segments.length > 2) {
				for (let i = 0; i < alternatives; ++i) {
					frames.push(DrawingTextureHackFrame.create(path, center, -rotation, Math.max(0.0, common.config.drawing.noise)));
				}
			}
		}
        
		return new DrawingTextureHack(frames, slot.data.name, path, offset);
	}

	constructor(frames, slotName, path, offset) {
		this.time = 0;
		this.animationSpeed = 14;

		this._frames = frames;
		this._slotName = slotName;
		this._path = path;
		this._offset = offset;
	}

	destroy() {
		for (let i = 0; i < this._frames.length; ++i) {
			const frame = this._frames[i];
			frame.texture.destroy(true);
		}
	}

	get frames() {
		return this._frames.slice();
	}

	get slotName() {
		return this._slotName;
	}

	get path() {
		return this._path;
	}

	get offset() {
		return this._offset;
	}
}